import type { Editor, JSONContent } from '@tiptap/react';

const extractMentions = (data: JSONContent) => {
  const mentions = (data.content || []).flatMap(extractMentions);
  if (data.type === 'mention') {
    if (data.attrs?.id) {
      mentions.push(data.attrs.id);
    }
  }

  const uniqueMentions: string[] = [...new Set(mentions)];

  return uniqueMentions;
};

export const getFeedbackInfo = (editor: Editor) => {
  const editorText = editor.getText();
  const content = editorText.replace(/[\r\n]+/g, '\r\n').trim();
  const ranges = editor.getJSON().content as JSONContent[];
  const mentions = extractMentions({ content: ranges });

  return {
    content,
    ranges,
    mentions,
  };
};
